import { useSelector } from "react-redux";
import Dashboard from "src/pages/Dashboard";
import InspectorDashboard from "src/pages/Dashboard/InspectorDashboard";
import { RootState } from 'src/redux-store/appStore';

function checkInspectorRole(userData) {
    // Check if userData and TownshipPermits exist
    if (!userData || !userData.TownshipPermits) {
      return false;
    }
    
    // Find department with ID 5
    const department = userData.TownshipPermits.find(dept => dept.DepartmentID === 5);
    
    // If department not found, return false
    if (!department || !department.Permits) {
      return false;
    }
    
    // Find permit with ID 9 in this department
    const permit = department.Permits.find(item => item.PermitID === 9);
    
    // Check if permit exists and has UserRoleName "Inspector"
    if (permit && permit.UserRoleName === "Inspector") {
      return true;
    }
    
    return false;
  }

const RedirectUserToDashboard = () => {
const userDetails = useSelector((store: RootState) => store.user.userDetails);
const result = checkInspectorRole(userDetails);

return result ? <InspectorDashboard /> : <Dashboard />
}

export default RedirectUserToDashboard;